import React, { useContext } from 'react';
import { BookingFormContext } from './context2';
import { SelectOrSuggestStep } from './components2/SelectOrSuggestStep';
import { GoalAndPurposeStep } from './components2/GoalAndPurposeStep';
import { LoginOrGuestStep } from './components2/LoginOrGuestStep';
import { ConfirmStep } from './components2/ConfirmStep';
import './styles.module.css';
import { ThankYouStep } from './components2/ThankYouStep';

const BookingForm: React.FunctionComponent = () => {
  const { state } = useContext(BookingFormContext);
  let content = <></>;

  if (state.step === 'select-time-or-suggest-timespans') {
    return <SelectOrSuggestStep />;
  }

  if (state.step === 'enter-goal-and-purpose') {
    return <GoalAndPurposeStep />;
  }

  if (['login-or-enter-as-guest', 'login-form', 'guest-form'].includes(state.step)) {
    return <LoginOrGuestStep />;
  }

  if (state.step === 'confirm-booking') {
    return <ConfirmStep />;
  }

  if (state.step === 'thankyou') {
    return <ThankYouStep />;
  }

  return content;
};

export default BookingForm;
